import React from "react";
import { Outlet } from "react-router-dom";
import toast from "react-hot-toast";
import useAuth from "../hooks/useAuth";

export default function Layout() {
  const { token, logout, loading } = useAuth();

  return (
    <div className="grid h-full grid-rows-[auto_1fr]">
       <header className="bg-black pt-6 pb-2.5">
        <div className="container mx-auto px-4 text-center ">
          <h1 className="text-white text-2xl font-almarai font-bold">Ascendra</h1>
        </div>
      </header>
      <main className="grid">
        <Outlet />
      </main>
    </div>
  );
}